import { ActionTree } from 'vuex';
import { IFieldState } from './field.store';
import {
  mutationSetLoading,
  mutationSetFields,
  mutationSetPageWidth,
  mutationUpdateField,
} from '@signing-page/fields/store/field.mutations';
import { FieldService } from '@signing-page/api/fields/services/field.service';
import { IRootState } from '@signing-page/store/store';
import { IField } from '@/fields/types/field';
import { translate } from '@/helpers/translation.helper';

export const actionLoadFields = 'loadFields';
export const actionLoadFieldsSuccess = 'loadFieldsSuccess';
export const actionLoadFieldsFailed = 'loadFieldsFailed';
export const actionUpdatePageWidth = 'updatePageWidth';

export const actionUpdateFieldValue = 'updateFieldValue';
export const actionUpdateFieldValueFailed = 'updateFieldValueFailed';

export const actions: ActionTree<IFieldState, IRootState> = {
  async [actionLoadFields]({ dispatch, commit, rootState }) {
    commit(mutationSetLoading, true);
    try {
      const {
        recipientId,
        documentId,
        authId,
      }: { recipientId: string; documentId: string; authId: string } = rootState;
      const fields: IField[] = await FieldService.loadFields(recipientId, documentId, authId);
      dispatch(actionLoadFieldsSuccess, fields);
    } catch (err) {
      dispatch(actionLoadFieldsFailed);
    }
  },
  async [actionLoadFieldsSuccess]({ commit }, fields: IField[]) {
    commit(mutationSetFields, fields);
    commit(mutationSetLoading, false);
  },
  async [actionLoadFieldsFailed]({ commit, dispatch }) {
    commit(mutationSetLoading, false);
    dispatch('alert/showDangerAlert', translate('failed-to-load-document-fields'), {
      root: true,
    });
  },
  async [actionUpdatePageWidth]({ commit }, pageWidth: number) {
    commit(mutationSetPageWidth, pageWidth);
  },
  async [actionUpdateFieldValue](
    { dispatch, commit, state },
    { fieldId, value }: { fieldId: string; value: string }
  ) {
    const oldField: IField = state.fields.find((field: IField) => field.id === fieldId);
    const updatedField: IField = { ...oldField, value };
    commit(mutationUpdateField, updatedField);
    try {
      await FieldService.updateField(fieldId, value);
    } catch (err) {
      dispatch(actionUpdateFieldValueFailed, { err, field: oldField });
    }
  },
  async [actionUpdateFieldValueFailed](
    { commit, dispatch },
    { field }: { err: Error; field: IField }
  ) {
    commit(mutationUpdateField, field);
    dispatch('alert/showDangerAlert', translate('failed-to-update-fields'), {
      root: true,
    });
  },
};
